import React from 'react';
import { Box, Container } from '@mui/material';
import TopLeftBg from "Assets/Icons/Discussion/top-left-bg.svg";
import TopLeftMain from "Assets/Icons/Discussion/top-left-main.svg";
import TopRightBg from "Assets/Icons/Discussion/top-right-bg.svg";
import TopRightMain from "Assets/Icons/Discussion/top-right-main.svg";

import BottomLeftBg from "Assets/Icons/Discussion/bottom-left-bg.svg";
import BottomLeftMain from "Assets/Icons/Discussion/bottom-left-main.svg";
import BottomRightBg from "Assets/Icons/Discussion/bottom-right-bg.svg";
import BottomRightMain from "Assets/Icons/Discussion/bottom-right-main.svg";

const bgImages = {
  topLeftBlob: TopLeftBg,
  topLeftStripes: TopLeftMain,
  topRightBlob: TopRightBg,
  topRightStripes: TopRightMain,
  bottomLeftBlob: BottomLeftBg,
  bottomLeftShape: BottomLeftMain,
  bottomRightBlob: BottomRightBg,
  bottomRightShape: BottomRightMain,
};

const backgroundElements = [
  {
    src: bgImages.topLeftBlob,
    style: { position: 'absolute', top: '5vh', left: 0, width: {md: '100px', lg: '120px'}, zIndex: 0 },
  },
  {
    src: bgImages.topLeftStripes,
    style: { position: 'absolute', top: '15vh', left: 0, width: {md: '60px', lg: '75px'}, zIndex: 1 },
  },
  {
    src: bgImages.topRightBlob,
    style: { position: 'absolute', top: '22vh', right: 0, width: {md: '100px', lg: '120px'}, zIndex: 0 },
  },
  {
    src: bgImages.topRightStripes,
    style: { position: 'absolute', top: '32vh', right: 0, width: {md: '60px', lg: '75px'}, zIndex: 1 },
  },
  {
    src: bgImages.bottomLeftBlob,
    style: { position: 'absolute', bottom: '13vh', left: 0, width: {md: '80px', lg: '100px'}, zIndex: 0 },
  },
  {
    src: bgImages.bottomLeftShape,
    style: { position: 'absolute', bottom: '32vh', left: '0.5vw', width: {md: '28px', lg: '32px'}, zIndex: 1 },
  },
  {
    src: bgImages.bottomRightBlob,
    style: { position: 'absolute', bottom: '0vh', right: 0, width: {md: '100px', lg: '120px'}, zIndex: 0 },
  },
  {
    src: bgImages.bottomRightShape,
    style: { position: 'absolute', bottom: '23vh', right: '0.5vw', width: {md: '40px', lg: '50px'}, zIndex: 1 },
  }
];

const styles = (theme) => ({
  padding: "-15px -24px",
  "& .main-container": {
    padding: "15px 24px",
    background: theme.palette.white.main
  }
});

const CommonWrapper = ({ width = "xl", children}) => {
  return (
    <Box sx={styles}>
      <Box
        sx={{
          bgcolor: '#f7f8fc',
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          position: 'relative',
          overflow: 'hidden',
          p: 2,
        }}
      >
        {/* Render all background images */}
        {backgroundElements.map((el, index) => (
          <Box
            key={index}
            component="img"
            src={el.src}
            alt={`background-shape-${index + 1}`}
            sx={{
              ...el.style,
              // Hide background art on small screens to keep the UI clean
              // display: { xs: 'none', md: 'block' },
            }}
          />
        ))}

        {/* Main Content Card */}
        <Container className="main-container" maxWidth={width} sx={{ zIndex: 2 }}>
          {children}
        </Container>
      </Box>
    </Box>
  );
};

export default CommonWrapper;